var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5vw",
    height: "5vw",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 29H30.5C30.2348 29 29.9804 29.1054 29.7929 29.2929C29.6054 29.4804 29.5 29.7348 29.5 30V50C29.5 50.2652 29.6054 50.5196 29.7929 50.7071C29.9804 50.8946 30.2348 51 30.5 51H33.5V29Z",
    fill: "#B1C7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 51H45.5V29H35.5V51ZM40.5 47C40.2348 47 39.9804 46.8946 39.7929 46.7071C39.6054 46.5196 39.5 46.2652 39.5 46C39.5 45.7348 39.6054 45.4804 39.7929 45.2929C39.9804 45.1054 40.2348 45 40.5 45C40.7652 45 41.0196 45.1054 41.2071 45.2929C41.3946 45.4804 41.5 45.7348 41.5 46C41.5 46.2652 41.3946 46.5196 41.2071 46.7071C41.0196 46.8946 40.7652 47 40.5 47ZM40.5 33C40.7652 33 41.0196 33.1054 41.2071 33.2929C41.3946 33.4804 41.5 33.7348 41.5 34C41.5 34.2652 41.3946 34.5196 41.2071 34.7071C41.0196 34.8946 40.7652 35 40.5 35C40.2348 35 39.9804 34.8946 39.7929 34.7071C39.6054 34.5196 39.5 34.2652 39.5 34C39.5 33.7348 39.6054 33.4804 39.7929 33.2929C39.9804 33.1054 40.2348 33 40.5 33ZM40.5 39C40.7652 39 41.0196 39.1054 41.2071 39.2929C41.3946 39.4804 41.5 39.7348 41.5 40C41.5 40.2652 41.3946 40.5196 41.2071 40.7071C41.0196 40.8946 40.7652 41 40.5 41C40.2348 41 39.9804 40.8946 39.7929 40.7071C39.6054 40.5196 39.5 40.2652 39.5 40C39.5 39.7348 39.6054 39.4804 39.7929 39.2929C39.9804 39.1054 40.2348 39 40.5 39Z",
    fill: "#3050F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 29H47.5V51H50.5C50.7652 51 51.0196 50.8946 51.2071 50.7071C51.3946 50.5196 51.5 50.2652 51.5 50V30C51.5 29.7348 51.3946 29.4804 51.2071 29.2929C51.0196 29.1054 50.7652 29 50.5 29Z",
    fill: "#2EC5CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.9af1d11a.svg";
export { ForwardRef as ReactComponent };